module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightCond.ttf?af2a6c476b2456e2cc975a3896a0aeed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightCond.ttf
// module id = 1387
// module chunks = 0